import { defaultDirection } from "../constants/defaultValues";
import moment from 'moment';

export const mapOrder = (array, order, key) => {
	array.sort(function (a, b) {
		var A = a[key], B = b[key];
		if (order.indexOf(A + "") > order.indexOf(B + "")) {
			return 1;
		} else {
			return -1;
		}
	});
	return array;
};


export const getDateWithFormat = () => {
	const today = new Date();
	let dd = today.getDate();
	let mm = today.getMonth() + 1; //January is 0!

	var yyyy = today.getFullYear();
	if (dd < 10) {
		dd = '0' + dd;
	}
	if (mm < 10) {
		mm = '0' + mm;
	}
	return dd + '.' + mm + '.' + yyyy;
}

export const getCurrentTime = () => {
	const now = new Date();
	return now.getHours() + ":" + now.getMinutes()
}

export const getDirection = () => {
	let direction = defaultDirection;
	if (localStorage.getItem("direction")) {
		const localValue = localStorage.getItem("direction");
		if (localValue === "rtl" || localValue === "ltr") {
			direction = localValue;
		}
	}
	return {
		direction,
		isRtl: direction === "rtl"
	};
};

export const setDirection = localValue => {
	let direction = "ltr";
	if (localValue === "rtl" || localValue === "ltr") {
		direction = localValue;
	}
	localStorage.setItem("direction", direction);
};

const getCurrentYear = () => {
	const d = new Date();
	const n = d.getFullYear()
	return n
}

const getCurrentMonth = () => {
	let monthString;
	const d = new Date();
	let n = d.getMonth() + 1;
	let monthStrings = n.toString()
	if (monthStrings.length === 1) {
		monthString = '0' + monthStrings
	} else {
		monthString = monthStrings
	}
	return monthString
}

export const getCurrentDate = () => {
	const d = new Date();
	const n = d.getDate();
	const newDate = ("0" + n).slice(-2)
	return newDate
}

const getMicroTime = () => {
	const d = new Date();
	const n = d.getMilliseconds();
	return n
}

const randomNumber = () => {
	const number = Math.round(Math.random() * 1000000)
	// const number = Math.round(number)
	return number
}

export const getOrderCode = () => {
	const orderCode = `01${getCurrentYear()}${getCurrentMonth()}${getMicroTime()}${randomNumber()}`
	return orderCode
}

export const getYearMontDate = () => {
	const yearMontDate = `${getCurrentYear()}-${getCurrentMonth()}-${getCurrentDate()}`
	return yearMontDate
}

export const getHours = () => {
	const d = new Date();
	const n = (d.getHours() < 10 ? '0' : '') + d.getHours();
	return n
}

export const getMins = () => {
	const d = new Date();
	const n = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
	return n
}

export const convertToYMD = (value) => {
	const d = (value.getDate() < 10 ? '0' : '') + value.getDate();
	const m = (value.getMonth() < 10 ? '0' : '') + value.getMonth();
	const y = value.getFullYear();
	const n = `${y}-${m}-${d}`
	return n
}

export const getOriginDateNow = () => {
	const d = new Date();
	return d
}


export const convertCommaNumberWith2Digit = (value) => {
	return Number(value).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const convertCommaNumber = (value) => {
	return Number(value).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

export function sortOrder(key, order = 'asc') {
	return function innerSort(a, b) {
		if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
			// property doesn't exist on either object
			return 0;
		}

		const varA = (typeof a[key] === 'string')
			? a[key].toUpperCase() : a[key];
		const varB = (typeof b[key] === 'string')
			? b[key].toUpperCase() : b[key];

		let comparison = 0;
		if (varA > varB) {
			comparison = 1;
		} else if (varA < varB) {
			comparison = -1;
		}
		return (
			(order === 'desc') ? (comparison * -1) : comparison
		);
	};
}

export const getHourData = () => {
	const hourLabelData = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
	return hourLabelData
}

export const getDateData = (days) => {
	let dateArr = []
	let dateAgo = moment(new Date()).add(-days, 'days').format('YYYY-MM-DD')
	for (let i = 1; i < days + 1; i++) {
		dateArr.push(moment(dateAgo).add(+i, 'days').format('YYYY-MM-DD'))
	}
	return dateArr
}

export const getMonthData = (months) => {
	let mounthArr = []
	let dateAgo = moment(new Date()).add(-months, 'months').format('YYYY-MM')
	for (let i = 1; i < months + 1; i++) {
		mounthArr.push(moment(dateAgo).add(+i, 'months').format('YYYY-MM'))
	}
	return mounthArr
}
